import { computed, Injectable, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationSkipped, NavigationStart, Router } from '@angular/router';

import { injectRequired } from 'src/app/infrastructure/functions/inject-required.function';

// Generieke "er gebeurt iets"-bron voor de footer-progressbar (ProgressBarComponent): lopende
// server-verzoeken (ApiService-middleware + progressInterceptor voor HttpClient/auth) en de router
// tijdens een navigatie (resolvers draaien vóór de route-component bestaat, dus vóór
// LoadingPageService.add in _BaseRouteComponent._ngOnInit). Zo geeft élke save/delete/login/
// navigatie feedback, zonder dat iedere aanroeper zelf iets hoeft te doen.
//
// Bewust eigen tellers i.p.v. loadKeys in IsLoadingService: LoadingService.reset() wist bij elke
// route-init álle loadKeys, en zou deze tellers dan midden in een lopend verzoek/navigatie op 0 zetten.
@Injectable({
    providedIn: 'root'
})
export class RequestLoadingService
{
    private readonly __router = injectRequired(Router);

    private readonly __requests$$ = signal(0);
    private readonly __navigating$$ = signal(false);

    readonly busy$$ = computed(() => this.__requests$$() > 0 || this.__navigating$$());
    readonly busy$ = toObservable(this.busy$$);

    constructor() {
        this.__router.events.subscribe(event => {
            if (event instanceof NavigationStart) {
                this.__navigating$$.set(true);
            } else if (
                event instanceof NavigationEnd
                || event instanceof NavigationCancel
                || event instanceof NavigationError
                || event instanceof NavigationSkipped
            ) {
                this.__navigating$$.set(false);
            }
        });
    }

    add(): void {
        this.__requests$$.update(n => n + 1);
    }

    remove(): void {
        this.__requests$$.update(n => Math.max(0, n - 1));
    }
}
